<template>
  <div>
    <Header></Header>
    <section class="top">
      <div>
        <h1>行业资讯</h1>
        <p>这里将分享最新的行业动态，政府政策以及泛物的成长路程</p>
      </div>

    </section>

    <div class="bot">
      <ul>
        <li v-for="(item,index) in arr" :key="index">
          <router-link :to="{ name: 'Details', query: {id: item.id} }">
          <el-row>
            <el-col :span="6">
              <img :src="url+item.imgUrl" alt="">

              </el-col>
            <el-col :span="18">
              <div class="title">{{item.title}}</div>
              <p>{{item.textinfo}}</p>
              </el-col>
          </el-row>
          </router-link>
        </li>
      </ul>
      <div class="more" @click="pageClick"><i class="el-icon-d-arrow-right" style="transform:rotate(90deg);"></i>查看更多</div>
    </div>



    <Footer></Footer>
  </div>
</template>

<script>
  export default {
    name: "Info",
    data() {
      return {
        arr: [],
        all: null, //总页数
        cur: 1, //当前页码
        totalPage: 0, //当前条数
        url: ''
      };
    },
    created() {
      this.dataListFn();
      //console.log(this.$api,'---00---')
      this.url = this.$api
    },
    methods: {
      topping: function(e) {
        console.log(e, '--00--');
      },
      //请求数据
      dataListFn: function(index) {
        this.$http
          .get("/api/websitemanager_v1/ApiController/getNewsList", {
            params: {
              pageNum: index,
              pageSize: "6",
              state: 0,
            },
          })
          .then((res) => {
          console.log(res);
            //console.log(res, "--00---");
            // this.arr = res.body.rows;
            for (var i = 0; i < res.body.rows.length; i++) {
              this.arr.push(res.body.rows[i])
            }

            //console.log(res.body.rows)
            this.all = Math.ceil((res.data.total) / 6); //总页数
            if (res.data.message == "success") {
              this.dataList = [];
              for (let i = 0; i < res.data.data.length; i++) {
                this.dataList.push(res.data.data[i]);
              }
              this.all = (res.data.totalPage); //总页数
              this.cur = (res.data.pageNum);
              this.totalPage = (res.data.totalPage);
            }
          });
      },

      pageClick: function() {
        //根据点击页数请求数据
        this.cur++
        this.dataListFn(this.cur.toString());
      },
    },
    computed: {
      //分页
      indexs: function() {
        var left = 1;
        var right = this.all;
        var ar = [];
        if (this.all >= 5) {
          if (this.cur > 3 && this.cur < this.all - 2) {
            left = this.cur - 2;
            right = this.cur + 2;
          } else {
            if (this.cur <= 3) {
              left = 1;
              right = 5;
            } else {
              right = this.all;
              left = this.all - 4;
            }
          }
        }
        while (left <= right) {
          ar.push(left);
          left++;
        }
        return ar;
      },
    },
  };
</script>

<style scoped="scoped" lang="scss">
  .top {
    background-image: url(../../static/img/topbging4.jpg);
    padding: 250px 0 250px;
    // text-align: center;
    position: relative;

    div{
      position: absolute;
      left: 18%;
      top: 42%;
      z-index: 9;
      h1 {
        color: #FFFFFF;
        &::before{
          content: '';
          width: 40px;
          height: 4px;
          margin-left: 8px;
          background-color: #FFFFFF;
          position: absolute;
          top: 60px;
          left: 0;
        }
      }
      p{
        margin-top: 30px;
        font-size: 17px;
        color: #FFFFFF;
      }
    }
  }


  .bot {

    max-width: 1400px;
    margin: 50px auto;
    overflow: hidden;
    padding: 20px;
    ul {
      li {
        margin-bottom: 70px;
      img{
        width: 100%;
        min-height: 170px;
      }
      .title{
              margin-left: 30px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            font-size: 20px;
            color: #494949;
            line-height: 40px;
            font-weight: bold;
      }
      p{
        margin-left: 30px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        line-height: 1.8;
        font-size: 10.5000pt;
        color: #8c8c8c;
        margin-top: 20px;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
      }
      }
    }
    .more{
      width: 100%;
      margin: 0 auto;
      text-align: center;
      padding-right: 20px;
      padding-left: 20px;
      height: 70px;
      background-color: #f6f7f8;
      position: relative;
      border-radius: 0;
      border-width: 0;
      color: rgba(115,115,131,1);
      font-size: 18px;
      vertical-align: middle;
      line-height: 70px;
      cursor: pointer;
    }
  }

  .page-bar {
    width: auto;
    height: 50px;
    margin: 40px auto;
    margin-top: 150px;
  }

  // ul {
  //   display: flex;
  //   justify-content: center;
  //   width: auto;
  // }

  ul,
  li {
    margin: 0px;
    padding: 0px;
  }

  li {
    list-style: none;
  }

  .page-bar li:first-child>a {
    margin-left: 0px;
  }

  .page-bar a {
    border: 1px solid #ddd;
    text-decoration: none;
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #5d6062;
    cursor: pointer;
    margin-right: 20px;
  }

  .page-bar a:hover {
    background-color: #eee;
  }

  .page-bar a.banclick {
    cursor: not-allowed;
  }

  .page-bar .active a {
    color: #fff;
    cursor: default;
    background-color: #e96463;
    border-color: #e96463;
  }

  .page-bar i {
    font-style: normal;
    color: #d44950;
    margin: 0px 4px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Info.vue